module.exports = __webpack_public_path__ + "static/img/zhada.bb46079f.png";